import { Ranch } from '../../../../../services/entities/impl/blfApi/schemas/ranch';

/**
 * Utility function to filter ranches based on customer ID
 * @param ranches - Array of ranches to filter
 * @param filterCustomerID - Customer ID to filter by
 * @returns Filtered array of ranches
 */
export const filterRanches = (
  ranches: Ranch[] | undefined,
  filterCustomerID: string
): Ranch[] => {
  if (!ranches) return [];

  // First filter the ranches based on the filterCustomerID if provided
  if (filterCustomerID !== '') {
    return ranches.filter((ranch) => ranch.customerID === filterCustomerID);
  }

  return ranches;
};
